import React, { useContext, useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import queryString from 'query-string';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import { useAlert } from 'react-alert';
import { AUTH_EXCEPTIONS, verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import Base, { ContentContainer } from '../../components/Base';
import { Button, Form, FormControl, InputError, Link, SignInButtons, } from '../../assets/styles/GlobalStyles';
import { createCookie, createCookieIw } from '../../utils/cookies';
import { LogoBgForm, LogoContainer } from "../../components/Base/styled";
import { LoadingContext } from '../../components/Loading/Loading.context';
import NewPassword from '../NewPassword';
import LogoImage from '../../assets/images/logo-login-imilk.png';
import { translate } from '../../i18n/index';
import { loginIw } from '../../services/services';


const SignIn = ({ history }) => {
    const alert = useAlert();
    const hasUsername = history.location.state ? history.location.state.username || '' : '';
    const hasPassword = history.location.state ? history.location.state.password || '' : '';
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const [newPassword, setNewPassword] = useState(false);
    const [responseSignIn, setResponseSignIn] = useState(null);
    const [username, setUsername] = useState(null);

    useEffect(() => {
        const logout = async () => {
            await Auth.signOut()
        }
        logout();
    }, []);

    useEffect(() => {
        if (responseSignIn !== null) {
            setNewPassword(true);
        }
    }, [responseSignIn]);
    
    const processLoginIw = async (password) => {
        const sendObj = { plainPassword: password }
        try {
            const response = await loginIw(sendObj)
            createCookieIw(response.data)
        } catch (e) {
            console.error(e)
        }
    }

    const redirect = async (response, password) => {
        createCookie(response);
        await processLoginIw(password)

        const { location } = history;
        const search = queryString.parse(location.search);

        if (Object.keys(search).length && search.login) {
            const url = atob(search.login);
            window.location.href = `https://${url}`;
            return;
        }

        window.location.href = `${process.env.REACT_APP_ADMIN_URL}`;
    }

    if (newPassword) {
        return <NewPassword responseSignIn={responseSignIn} username={username} redirect={redirect} />
    }

    return (
        <>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                </LogoContainer>
            </div>

            {/* TELA DE LOGIN IMILK*/}
            <Base width="480" marginTop="450" isStore={false} isAppWeb={false} isImilk={true} backgroundForm={'#FFF;'}>
                <ContentContainer>

                    <LogoBgForm src={LogoImage} alt="Logo do site" title="iMilk" />
                    <Formik
                        enableReinitialize
                        initialValues={{
                            username: hasUsername,
                            password: hasPassword,
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().required(translate('validateRequired')),
                            password: Yup.string().required(translate('validateRequired')),
                        })}
                        onSubmit={async (values, actions) => {
                            if (values) {
                                showLoading();
                                try {
                                    const response = await Auth.signIn(values.username.trim(), values.password.trim());
                                    if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
                                        setResponseSignIn(response)
                                        setUsername(values.username.trim())
                                        hideLoading();
                                        return;
                                    }

                                    await redirect(response, values.password.trim())

                                } catch (e) {
                                    console.log('ERROR LOGIN:  ', e)
                                    alert.show(verifyError(e.code, e.message), {
                                        closeCopy: 'Fechar',
                                        onClose: () => {
                                            if (
                                                e.code === 'UserNotFoundException' &&
                                                e.message.includes(AUTH_EXCEPTIONS.MISSING_EMAIL_AND_CELLPHONE)
                                            ) {

                                            }
                                        },
                                    });
                                }

                                hideLoading();
                            }
                            actions.setSubmitting(false);
                        }}>
                        {({ isSubmitting }) => (

                            <Form>
                                <>
                                    <FormControl>
                                        <Field
                                            autocapitalize="off"
                                            name="username"
                                            placeholder={translate('inputUsername')}
                                            component={Input}
                                        />
                                        <ErrorMessage name="username" component={InputError} />
                                    </FormControl>

                                    <FormControl>
                                        <Field
                                            type="password"
                                            name="password"
                                            placeholder={translate('inputPassword')}
                                            component={Input}
                                        />
                                        <ErrorMessage name="password" component={InputError} />
                                    </FormControl>
                                </>


                                <FormControl style={{ marginBottom: 0 }}>
                                    <Link
                                        to={{
                                            pathname: '/esqueci-minha-senha',
                                            search: history.location.search,
                                        }}>
                                        {translate('loginResetPassword')}
                                    </Link>
                                </FormControl>

                                <FormControl style={{ marginTop: 15 }}>
                                    <SignInButtons>
                                        <Button type="submit" disabled={isSubmitting}>
                                            {isSubmitting ? translate('buttonEntering') : translate('buttonEnter')}
                                        </Button>
                                    </SignInButtons>
                                </FormControl>


                            </Form>
                        )}
                    </Formik>
                </ContentContainer>
            </Base>
        </>
    );
};

export default SignIn;
